//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CloudDM.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["nObjects","checkedOutObjects","nUncheckedOutObjects","uncheckedOutObjects"],"GetCheckedoutStatusOfAllObjectsInSession",{},0,0],[["operation"],"CreatePartOperationBuilder",{R_:{builder:"CloudDM.PartOperationBuilder"}},1,0],[["containerInfo"],"CreateProject",{R_:{containerId:''}},1,0],[["containerId"],"DeleteProject",{},1,0],[["partInputs","numDesigns"],"ImportParts",{R_:{designs:""}},1,0],[[],"GetConnectorHome",{R_:{container:''}},0,0],[["numProjects"],"GetSynchedProjects",{R_:{containers:""}},0,0],[["numProjects"],"GetSynchedProjectsSharedWithMe",{R_:{containers:""}},0,0]],[["FileManagement","CloudDM.FileManagement",0],["PartUtils","CloudDM.PartUtils",0]]];
SPLM.CloudDM.DataManager = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CloudDM.DataManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CloudDM.DataManager.ContainerInfo = class{
    constructor(name,description,path,ownerName,tenantName){
        this.name=name;this.description=description;this.path=path;this.ownerName=ownerName;this.tenantName=tenantName;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Description(){return this.description}
    set Description(val){this.description = val}
    get Path(){return this.path}
    set Path(val){this.path = val}
    get Ownername(){return this.ownerName}
    set Ownername(val){this.ownerName = val}
    get Tenantname(){return this.tenantName}
    set Tenantname(val){this.tenantName = val}
};

SPLM.CloudDM.DataManager.ImportPartInput = class{
    constructor(localFileName,relativeFilePath){
        this.localFileName=localFileName;this.relativeFilePath=relativeFilePath;}
    get Localfilename(){return this.localFileName}
    set Localfilename(val){this.localFileName = val}
    get Relativefilepath(){return this.relativeFilePath}
    set Relativefilepath(val){this.relativeFilePath = val}
};

SPLM.CloudDM.DataManager.ImportPartDesign = class{
    constructor(inputPart,revisionUrn,downloadTicket){
        this.inputPart=inputPart;this.revisionUrn=revisionUrn;this.downloadTicket=downloadTicket;}
    get Inputpart(){return this.inputPart}
    set Inputpart(val){this.inputPart = val}
    get Revisionurn(){return this.revisionUrn}
    set Revisionurn(val){this.revisionUrn = val}
    get Downloadticket(){return this.downloadTicket}
    set Downloadticket(val){this.downloadTicket = val}
};

export default SPLM;